import { mapGetters, mapActions } from 'vuex'

export const notificationsActions = {
  ...mapActions('notifications', ['add', 'remove'])
}

export const notificationsData = {
  ...mapGetters('notifications', ['notifications'])
}

export const panelData = {
  ...mapGetters('panel', ['isBusy'])
}

export const panelActions = {
  ...mapActions('panel', ['panelBusy', 'panelUnnocupied'])
}

export const footerData = {
  ...mapGetters('footer', ['helps', 'socials'])
}

export const userActions = {
  ...mapActions('user', [
    'login',
    'checkFirmaAccountWithIdentityToken',
    'signup',
    'setUser',
    'logout',
    'updateAccount',
    'getAccount',
    'checkIdentityAccount'
  ])
}

export const userData = {
  ...mapGetters('user', [
    'loggedIn',
    'userData',
    'accountData',
    'userId',
    'identidadesSingin',
    'identidadesPasswordRecovery',
    'catchPassReset',
    'catchCancelPassReset'
  ])
}

export const appThemeData = {
  ...mapGetters('mainTheme', [
    'appThemeBackgroundColor',
    'appThemeComponentsMainColor',
    'appThemeSelectFileButtonColor',
    'appThemeBackgroundWelcome'
  ])
}

export const appData = {
  ...mapGetters('mainApp', ['appDrawer'])
}

export const appActions = {
  ...mapActions('mainApp', ['setAppDrawer'])
}

/**
 * @summary Genera un evento de notificacion
 * @description Agregar un evento de notificacion al store de notificaciones y lo muestra por 10 segundos en el notification-container.
 * @author Francisco Ibarra
 * @param {object} store    El store de la aplicacion (reguralmente this.$store)
 * @param {string} message  El mensaje que mostrará la notificacion.
 * @param {string} type     El tipo de notificación mostrado en en el alert: success | info | error | warning.
 * @param {string} border   El borde que se dibujara en el alert acepta  top | right | bottom | left.
 * @param {boolean} dismissible  Agregar un boton de cerrar a la notificacion
 * @param {boolean} isLocal  Cuando es verdadero solo muestra los mensajes definidos como locales en la notificacion bar.
 * @param {int} timeToHide Cuando es mayor a cero sobrescribe el tiempo de ocultamiento configurado en la variable de ambiente.
 */
export const pushNotification = (
  store,
  message,
  type = 'success',
  border = undefined,
  dismissible = false,
  isLocal = false,
  timeToHide = 0
) => {
  const notification = {
    message,
    type,
    border,
    dismissible,
    isLocal,
    timeToHide
  }

  store.dispatch('notifications/add', notification, { root: true })
}

export const resourceActions = {
  ...mapActions('resource', ['noticeOfPrivacy', 'termsAndConditions'])
}

export const resourceData = {
  ...mapGetters('resource', [
    'codeResourceServiceGet200',
    'msgResourceServiceError'
  ])
}

export const messageErrorResponse = response => {
  try {
    return response.data.successful.message
  } catch {
    try {
      return response.response.data.successful.message
    } catch {
      try {
        return response.response.data.error.message
      } catch {
        try {
          return response.error.message
        } catch {
          return ''
        }
      }
    }
  }
}
